export const MobileMask: (string | RegExp)[] = [
	/0/,
	/[4]/,
	/\d/,
	/\d/,
	" ",
	/\d/,
	/\d/,
	/\d/,
	" ",
	/\d/,
	/\d/,
	/\d/,
];
